import { Cell, Grid, Heading, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { Color } from 'csstype'
import { formatDate } from 'util/date/formatDate'

import { BuscaCidadaoQueryResultModel } from '../../model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'
import { renderTelefone } from '../table/render-acompanhamentoCondicaoSaudeColumns'
import { formatSexoIdentidadeGeneroRacaCor } from './formatter-acompanhamentoCondicaoSaudeAccordion'

interface AcompanhamentoCondicaoSaudeDadosCadastraisAccordionSectionProps {
  row: BuscaCidadaoQueryResultModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeDadosCadastraisAccordionSection(
  props: Readonly<AcompanhamentoCondicaoSaudeDadosCadastraisAccordionSectionProps>
) {
  const { row, iconColor } = props

  const { cnsCidadao, endereco, dataNascimentoCidadao } = row

  return (
    <Grid key={cnsCidadao} gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon width='1rem' icon='userCardFilled' color={iconColor} />
          <Heading level={5}>Dados cadastrais</Heading>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Telefone</Text>
          <Text>{renderTelefone(row)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Endereço</Text>
          <Text>{endereco?.titleCase()}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Data de nascimento</Text>
          <Text>{formatDate(dataNascimentoCidadao)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Sexo, identidade de gênero e raça/cor</Text>
          <Text>{formatSexoIdentidadeGeneroRacaCor(row)}</Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}
